import { obLazyRender } from "../../lib/utils/browser/obInterSection";
/** 传入props.lazyRender===true时 当组件第一次可见之后renderSlot为true */
export const lazyRenderMixin = {
  props: {
    lazyRender: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lazyRenderMixinComponentVisible: false,
      lazyRenderMixinIsDesignMode: false
    };
  },
  created() {
    this.lazyRenderMixinIsDesignMode = !!this.$attrs['data-uc-design-mode'];
  },
  mounted() {
    if (this.lazyRenderMixinEnableLazyRender) {
      this.lazyRenderMixinUnOb = obLazyRender(this.$el, () => {
        this.lazyRenderMixinComponentVisible = true;
      });
    }
  },
  beforeDestroy() {
    if (this.lazyRenderMixinEnableLazyRender) {
      var _this$lazyRenderMixin;
      (_this$lazyRenderMixin = this.lazyRenderMixinUnOb) === null || _this$lazyRenderMixin === void 0 || _this$lazyRenderMixin.call(this);
    }
  },
  computed: {
    lazyRenderMixinEnableLazyRender() {
      return this.lazyRender && !this.lazyRenderMixinIsDesignMode;
    },
    renderSlot() {
      // 开了懒加载 并且是 运行时 依据组件是否可见过 进行渲染
      return !this.lazyRenderMixinEnableLazyRender || this.lazyRenderMixinComponentVisible;
    }
  }
};
//# sourceMappingURL=lazyRenderMixin.js.map
